import { EntrataApplicationStage, EntrataApplicationStatus } from '@common/entities';

export interface LeaseApplicationStatus {
  applicationStage: EntrataApplicationStage;
  applicationStatus: EntrataApplicationStatus;
}

export const isLeaseCompletedApplication = ({
  applicationStage,
  applicationStatus,
}: LeaseApplicationStatus): boolean =>
  applicationStage === EntrataApplicationStage.Lease &&
  (applicationStatus === EntrataApplicationStatus.PartiallyCompleted ||
    applicationStatus === EntrataApplicationStatus.Completed);
